export const COUNTER_VALUE = 900



// WEBPACK FOOTER //
// ./src/config/constants.js